import gql from 'graphql-tag';
import ORGANIZATION_FRAGMENT from '../fragments/organization';

const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation updateOrganization($data: OrganizationUpdateInput!, $where: OrganizationWhereInput!) {
    updateOrganization(data: $data, where: $where) {
      ...BaseOrganization
    }
  }
  ${ORGANIZATION_FRAGMENT}
`;

export default UPDATE_ORGANIZATION_MUTATION;
